import * as favoriteNodeParser from '../helpers/favoriteNodeParser';
import updateFavoritesUserOptionService from '../../services/v1/updateFavoritesUserOptionService';
import { ObservableMap } from 'mobx';
import favoritesStore from '../../store/store';
import {
    FavoritePersonaNode,
    FolderForestNode,
    FavoriteSearchNode,
    FavoriteCategoryNode,
} from 'owa-favorites-types';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { action, select } from 'satcheljs/lib/legacy';

export interface UpdateFavoritesUserOptionState {
    favoritesFolderNodes: ObservableMap<string, FolderForestNode>;
    favoritesPersonaNodes: ObservableMap<string, FavoritePersonaNode>;
    favoriteSearches: ObservableMap<string, FavoriteSearchNode>;
    favoriteCategories: ObservableMap<string, FavoriteCategoryNode>;
    orderedFavoritesNodeIds: string[];
}

export default action('updateFavoritesUserOption')(
    select({
        favoritesFolderNodes: () => favoritesStore.favoritesFolderNodes,
        favoritesPersonaNodes: () => favoritesStore.favoritesPersonaNodes,
        favoriteSearches: () => favoritesStore.favoriteSearches,
        favoriteCategories: () => favoritesStore.favoriteCategories,
        orderedFavoritesNodeIds: () => favoritesStore.orderedFavoritesNodeIds,
    })(function updateFavoritesUserOption(state?: UpdateFavoritesUserOptionState): Promise<void> {
        const favoriteNodesRaw = favoriteNodeParser.serialize(
            state.orderedFavoritesNodeIds,
            state.favoritesFolderNodes,
            state.favoritesPersonaNodes,
            state.favoriteSearches,
            state.favoriteCategories
        );

        // Update the local user configuration store
        getUserConfiguration().UserOptions.FavoriteNodes = favoriteNodesRaw;

        // Service request to update user options for FavoriteFolders
        return updateFavoritesUserOptionService(favoriteNodesRaw);
    })
);
